/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useProyectos from "../../hooks/useProyectos";
import ModalAdd from "./Modals/ModalAdd";
import { Link as LinkReact } from "react-router-dom";
import DataTable from "../../components/DataTable/DataTable";
import BotonesExcel from "../../components/Presupuesto/BotonesExcel";
import Title from "../../components/Form/Title";
import ReadOnlyNote from "../../components/Form/ReadOnlyNote";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";
import { useDispatch } from "react-redux";
import useLogin from "../../hooks/useLogin";
import Swal from "sweetalert2";

export default function Index() {
  const { token, user_rol, cliente_id } = useLogin();
  const dispatch = useDispatch();
  const { loading, error, message, success, Proyectos, ProyectosGetService, ProyectosDeleteService } = useProyectos();
  const [modal, setModal] = useState(false);
  const [Update, setUpdate] = useState(false);
  const [Id, setId] = useState("");
  const [Client, setClient] = useState("");
  const [Nombre, setNombre] = useState("");
  const [Empresa, setEmpresa] = useState("");
  const [FechaInicial, setFechaInicial] = useState("");
  const [FechaFinal, setFechaFinal] = useState("");
  const [NumeroUsers, setNumeroUsers] = useState("");
  const [TotalPersonal, setTotalPersonal] = useState("");
  const [Status, setStatus] = useState("");
  const [Productor, setProductor] = useState("");
  const [Director, setDirector] = useState("");
  const [Ejecutivo, setEjecutivo] = useState("");
  const canManage = user_rol === "super administrador" || user_rol === "cliente";

  const toggle = () => {
    setModal(!modal);
    setUpdate(false);
    setId("");
    setClient("");
    setNombre("");
    setEmpresa("");
    setFechaInicial("");
    setFechaFinal("");
    setNumeroUsers("");
    setTotalPersonal("");
    setStatus("");
    setProductor("");
    setDirector("");
    setEjecutivo("");
  };

  useEffect(() => {
    dispatch(setTitle("Descargando proyectos"));
    dispatch(showLoader());
    ProyectosGetService(token);
    return () => {};
  }, []);

  useEffect(() => {
    if (Proyectos.length >= 0) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
    return () => {};
  }, [Proyectos]);

  useEffect(() => {
    if (success === true) {
      ProyectosGetService(token);
    }
  }, [ProyectosGetService, success]);

  const Eliminar = (e) => {
    Swal.fire({
      title: "¿Eliminar proyecto?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#3b82f6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      const data = new FormData();
      data.append("id", e);
      ProyectosDeleteService(data, token);

      Swal.fire({
        title: "Espere por favor...",
        text: "Cargando...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        icon: "question",
        onOpen: () => {
          Swal.showLoading();
        },
      });
    });
  };

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success]);

  useEffect(() => {
    if (error) {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Error",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, error]);

  const columns = [
    { field: "nombre", title: "Nombre" },
    { field: "empresa", title: "Empresa" },
    { field: "fecha_inical", title: "Fecha inicial" },
    { field: "fecha_final", title: "Fecha final" },
  ];

  if (canManage) {
    columns.push(
      { field: "numero_usuarios", title: "Usuarios" },
      { field: "total_personal", title: "Total personal" }
    );
  }

  columns.push(
    { field: "productor", title: "Productor" },
    { field: "director_de_produccion", title: "Director de producción" },
    { field: "productor_ejecutivo", title: "Productor ejecutivo" }
  );

  if (canManage) {
    columns.push({
      field: "Enlaces",
      title: "Enlaces",
      align: "center",
      sortable: false,
      filterable: false,
      render: (row) => (
        <div className="crud-actions">
          {/* En la URL va el uuid del proyecto y no su id, que dejaba entrar a
              los proyectos de al lado cambiando el número a mano. */}
          <LinkReact
            to={"/presupuestos/" + (row.uuid ?? row.id)}
            className="crud-icon-btn password"
            title="Presupuesto"
          >
            <i className="bi bi-cash-coin"></i> Presupuesto
          </LinkReact>
          <LinkReact
            to={"/presupuesto-resumen/" + (row.uuid ?? row.id)}
            className="crud-icon-btn edit"
            title="Portada, esquema financiero y flujo de efectivo"
          >
            <i className="bi bi-file-earmark-spreadsheet"></i> Resumen
          </LinkReact>
          <LinkReact
            to={"/dashboard-cliente/" + row.id}
            className="crud-icon-btn edit"
            title="Dashboard"
          >
            <i className="bi bi-grid-1x2"></i> Dashboard
          </LinkReact>
        </div>
      ),
    });

    columns.push({
      field: "Excel",
      title: "Presupuesto en Excel",
      align: "center",
      sortable: false,
      filterable: false,
      render: (row) => (
        <BotonesExcel
          proyecto={row}
          token={token}
          onImportado={() => ProyectosGetService(token)}
        />
      ),
    });

    columns.push({
      field: "Acciones",
      title: "Acciones",
      align: "center",
      sortable: false,
      filterable: false,
      render: (row) => (
        <div className="crud-actions">
          <button
            className="crud-icon-btn edit"
            title="Editar"
            onClick={() => {
              setId(row.id);
              setClient(row.nombre_comercial);
              setNombre(row.nombre);
              setEmpresa(row.empresa);
              setFechaInicial(row.fecha_inical);
              setFechaFinal(row.fecha_final);
              setNumeroUsers(row.numero_usuarios);
              setTotalPersonal(row.total_personal);
              setStatus(row.status);
              setProductor(row.productor);
              setDirector(row.director_de_produccion);
              setEjecutivo(row.productor_ejecutivo);
              setUpdate(true);
              setModal(true);
            }}
          >
            <i className="bi bi-pencil"></i> Editar
          </button>
          <button
            className="crud-icon-btn delete"
            title="Eliminar"
            onClick={() => {
              Eliminar(row.id);
            }}
          >
            <i className="bi bi-trash"></i> Eliminar
          </button>
        </div>
      ),
    });
  }

  return (
    <>
      <ModalAdd
        modal={modal}
        toggle={toggle}
        Client={Client}
        Nombre={Nombre}
        Empresa={Empresa}
        FechaInicial={FechaInicial}
        FechaFinal={FechaFinal}
        NumeroUsers={NumeroUsers}
        TotalPersonal={TotalPersonal}
        Status={Status}
        Productor={Productor}
        Director={Director}
        Ejecutivo={Ejecutivo}
        Update={Update}
        Id={Id}
        token={token}
        user_role={user_rol}
        cliente_id={cliente_id}
        setClient={setClient}
        setNombre={setNombre}
        setEmpresa={setEmpresa}
        setFechaInicial={setFechaInicial}
        setFechaFinal={setFechaFinal}
        setNumeroUsers={setNumeroUsers}
        setTotalPersonal={setTotalPersonal}
        setStatus={setStatus}
        setProductor={setProductor}
        setDirector={setDirector}
        setEjecutivo={setEjecutivo}
        ProyectosGetService={ProyectosGetService}
      />
      <div className="container">
        <div className="crud-header">
          <Title title="Listado de Proyectos" className="crud-title" />
          {canManage ? (
            <button className="crud-add-btn" onClick={toggle}>
              <i className="bi bi-plus-lg"></i>
              Agregar proyecto
            </button>
          ) : (
            <ReadOnlyNote />
          )}
        </div>
        <div className="crud-card">
          <DataTable tableKey="proyectos" loading={loading} columns={columns} data={Proyectos} />
        </div>
      </div>
    </>
  );
}
